import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getUserId = () => {
  let uid = localStorage.getItem('quiz_user_id');
  if (!uid) {
    uid = crypto.randomUUID();
    localStorage.setItem('quiz_user_id', uid);
  }
  return uid;
};

export const getAdminToken = () => localStorage.getItem('admin_token');

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use(config => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LEVEL_LABELS = {
  anfaenger: 'Anfänger',
  fortgeschritten: 'Fortgeschritten',
  experte: 'Experte'
};

export const LEVEL_ORDER = ['anfaenger', 'fortgeschritten', 'experte'];
